import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { Store } from "redux";
import { Provider } from "react-redux";
import { createBrowserHistory, History } from "history";
import IStore from "./models/IStore";
import rootStore from "./stores/rootStore";
import App from "./views/App";
import environment from "environment";
import * as serviceWorker from "./serviceWorker";
import "./i18n";
import i18next from "i18next";
import(`./brands/${process.env.REACT_APP_BRAND}/index.scss`);
require("typeface-ibm-plex-sans");

i18next.on("initialized", function (options) {
    (async (window: Window): Promise<void> => {
        const initialState: Partial<IStore> = {};
        const history: History = createBrowserHistory({ basename: environment.route.baseRoute });
        const store: Store<IStore> = rootStore(initialState, history);

        const rootEl: HTMLElement | null = document.getElementById("root");
        const render = (Component: typeof App, el: HTMLElement | null): void => {
            ReactDOM.render(
                <Provider store={store}>
                    <Component history={history} dispatch={store.dispatch} />
                </Provider>,
                el
            );
        };

        render(App, rootEl);
    })(window);
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
